import React, { Component } from 'react'
import classnames from 'classnames'
import Config from '../../Config'
import Card from '@material-ui/core/Card'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { localize, localizeImg } from '../../util/Localizer'
import ContactUs from './ContactUs'
import About from './About'
import { connect } from 'react-redux'
import { toggleLanguage } from '../../redux/actions/languageActions'
import { submitAgain } from '../../redux/actions/submitNavigationActions'
import { injectIntl } from 'react-intl'
import { logout } from '../../redux/actions/logoutActions'
import ButtonStyles from '../../styles/buttons'
import TabStyles from '../../styles/tabs'
import HeaderStyles from '../../styles/components/header'
import DrawerStyles from '../../styles/components/drawer'
import RBButton from '../../controls/RBButton'

import Drawer from '@material-ui/core/Drawer'
// import MenuIcon from '@material-ui/icons/Menu'

import Divider from '@material-ui/core/Divider'
import NgrxAuth from '../../auth/Auth'
import Quicklinks from './quickLinks'
import { push } from 'connected-react-router'

// icons

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'

import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

const defaultActiveTab = 'Claims'

class Header extends Component {
  constructor (props) {
    super(props)

    this.close = this.close.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
    this.pushUser = this.pushUser.bind(this)
    this.pushFaq = this.pushFaq.bind(this)
    this.pushBenefits = this.pushBenefits.bind(this)
    this.pushPension = this.pushPension.bind(this)
    this.pushHcsa = this.pushHcsa.bind(this)
    this.updateTab = this.updateTab.bind(this)
    this.submitClaim = this.submitClaim.bind(this)
    this.logout = this.logout.bind(this)
    this.setLang = this.setLang.bind(this)
    this.renderMobileHeader = this.renderMobileHeader.bind(this)

    this.state = {
      open: false,
      activeTab: defaultActiveTab,
      headerHeight: 0,
      openMember: false
    }
  }

  componentDidMount () {
    const components = this.props.currentPath.split('/').filter(c => (c.length > 0))
    const currentTab = (components.length > 0) ? components[0] : defaultActiveTab
    const activeTab = (currentTab === 'AssociatedClaimLines') ? 'Claims' : currentTab
    this.setState({ activeTab: activeTab || defaultActiveTab })

    // get the header height
    const header = document.getElementsByClassName('header')
    if (header.length === 1) {
      const headerHeight = header[0].clientHeight
      this.setState({ headerHeight })
    }
  }

  // gets the height of the header when it's rendered. This is dynamically set by the component
  get headerHeight () {
    return this.headerHeight
  }

  handleToggle () {
    this.setState({ open: !this.state.open })
  }

  close () {
    this.setState({ open: false })
  }

  pushUser (e) {
    e.preventDefault()
    this.props.push('/UserProfile')
    this.close()
  }

  pushBenefits (e) {
    e.preventDefault()
    this.props.push('/Member/Benefits')
    this.close()
  }

  pushPension (e) {
    e.preventDefault()
    this.props.push('/Member/Pension')
    this.close()
  }

  pushHcsa (e) {
    e.preventDefault()
    this.props.push('/Member/Hcsa')
    this.close()
  }

  pushFaq (e) {
    e.preventDefault()
    this.props.push('/faq')
    this.close()
  }

  updateTab (e, v) {
    // Note: e (event) is not guaranteed to be defined.
    switch (v.toString().toLowerCase()) {
      case 'member':
        this.props.push('/Member/MemberSummary')
        break
      case 'claims':
        this.props.push(`/${v}`)
        break
      case 'resources':
        this.props.push(`/${v}`)
        break
      case 'providers':
        this.props.push(`/${v}`)
        break
      default:
        this.props.push('/Member/MemberSummary')
        break
    }
    this.setState({ open: false })
  }

  submitClaim () {
    const memberSummary = this.props.memberSummary || {}
    if (window.location.pathname.includes('SubmitAClaim')) {
      this.setState({ open: false })
    } else {
      if (Object.keys(memberSummary).length === 0 || 'error' in memberSummary) {
      } else {
        if (window.localStorage.isWelcomePageShown) {
          this.props.submitAgain()
        }
        // go to submit a claim
        this.props.push('/SubmitAClaim')
        this.setState({ open: false })
      }
    }
  }

  setLang (e) {
    e.preventDefault()
    this.props.toggleLanguage()
  }

  logout (e) {
    e.preventDefault()
    this.props.logout()
  }

  showPrintClaims () {
    return (this.props.currentPath === '/Claims')
  }

  renderDesktopHeader () {
    const { classes = {} } = this.props
    const logo = localizeImg('/img/logo.svg')
    const self = this
    const appContent = this.props.appContent.content
    const activeTab = this.state.activeTab !== 'Member' && this.state.activeTab !== 'Claims' && this.state.activeTab !== 'Resources' && this.state.activeTab !== 'Providers' ? false : this.state.activeTab

    const isBenefitsAvailable = this.props.memberSummary && this.props.memberSummary.isBenefitsAvailable
    const isProvidersAvailable = Config.providers.isTabAvailable
    const logoLink = Config.landingPage
    const useLocale = Config.useLocale

    return (
      <Row className='desktopMenu'>
        <Col lg={1} className={classes.headerLogo}>
          <img src={logo} alt={localize('pages.login.logoAlt')} onClick={(e) => { self.updateTab(e, logoLink) }} />
        </Col>
        <Col lg={10} className='clearMLR desktopMenuContent' style={{ position: 'relative' }}>
          <Row between='lg' className='mainHeaderTop'>
            <Col>
              <div className='userLink navLinks'>
                <Icon color='primary'>account_circle</Icon>
                <a href='' onClick={(e) => {
                  e.preventDefault()
                  this.props.push('/UserProfile')
                }}>{NgrxAuth.name}</a>
                <p className='policyNum'>{localize('common.header.policy')}: <span style={{ fontWeight: 300 }}>{NgrxAuth.policyNumber}</span></p>
                <p className='policyNum'>{localize('common.header.certificate')}: <span style={{ fontWeight: 300 }}>{NgrxAuth.certificateNumber}</span></p>
              </div>
            </Col>
            <Col>
              <div className='upperNav navLinks'>
                {useLocale && <div>
                  <a href='' id='setFrench' onClick={this.setLang}>{localize('common.nav.language')}</a>
                </div>}
                <ContactUs appContent={appContent.contact}/>
                <div>
                  <a href='' id='pushFaq' onClick={this.pushFaq}>{localize('common.contactus.faq')}</a>
                </div>
                <About appContent={appContent.about} />
                <div>
                  <a href='' id='logout' onClick={this.logout}>{localize('pages.home.logout')}</a>
                </div>
              </div>
            </Col>
          </Row>
          <Row between='lg' className={classes.headerTabContainer}>
            <Col className={classes.tabBar}>
              <Tabs className='mainTabs' indicatorColor={'primary'} value={activeTab} onChange={this.updateTab} >
                <Tab value='Member' label={localize('common.header.member')} ref={(tab) => { this.member = tab }} className={classnames(classes.MainTab, activeTab === 'Member' ? 'active' : null)} />
                {isBenefitsAvailable ? <Tab value='Claims' label={localize('common.header.claims')} ref={(tab) => { this.claims = tab }} className={classnames(classes.MainTab, activeTab === 'Claims' ? 'active' : null)} /> : null}
                {NgrxAuth.isAnyMemberResource ? <Tab value='Resources' label={localize('common.header.resources')} ref={(tab) => { this.resources = tab }} className={classnames(classes.MainTab, activeTab === 'Resources' ? 'active' : null)} /> : ''}
                {isProvidersAvailable && <Tab value='Providers' label={localize('common.header.providers')} ref={(tab) => { this.providers = tab }} className={classnames(classes.MainTab, activeTab === 'Providers' ? 'active' : null)} />}
              </Tabs>
            </Col>
            <Col className={classes.headerButtons}>
              { isBenefitsAvailable ? <Quicklinks showPrintClaims={this.showPrintClaims()} /> : null}
              {NgrxAuth.canSubmitClaim && isBenefitsAvailable ? <RBButton
                className={classnames(classes.raisedButton, classes.submitClaimButton)}
                label={localize('common.header.submitClaim')}
                containerElement='label'
                variant='contained'
                onClick={self.submitClaim}
                disabled={this.props.isLoading}
                primary
                icon={<Icon color='inherit'>add</Icon>}
              /> : null}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
  renderMobileHeader () {
    const { classes = {} } = this.props
    const logo = localizeImg('/img/logo.svg')
    const self = this
    const appContent = this.props.appContent.content
    const isBenefitsAvailable = this.props.memberSummary && this.props.memberSummary.isBenefitsAvailable
    const isProvidersAvailable = Config.providers.isTabAvailable
    const logoLink = Config.landingPage
    const useLocale = Config.useLocale

    return (
      <Row className='responsive_menu'>
        <div className='responsive_menu_header'>
          <div className={classnames(classes.drawerMenuItem, 'responsiveLogo')}><img src={logo} alt={localize('pages.login.logoAlt')} onClick={(e) => { self.updateTab(e, logoLink) }} /></div>
          <IconButton
            color="inherit"
            className={classnames(classes.iconButton, classes.hamburgerIcon)}
            onClick={this.handleToggle}
            role='menu'>
            <Icon color='inherit' style={{ fontSize: 45 }}>menu</Icon>
          </IconButton>
        </div>
        <Drawer
          open={this.state.open}
          onClose={this.handleToggle}
        >
          <div style={{ width: 300 }}>
            <RBButton
              label={NgrxAuth.name}
              fullWidth
              color
              icon={<Icon color='primary'>account_circle</Icon>}
              onClick={this.pushUser} s
              styles={{ fontSize: '0.88rem', height: 48 }}
            />
            <div className={classes.drawerMenuItem}>
              <p className='policyNum' style={{ margin: '5px 0px' }}>{localize('common.header.policy')}: <span style={{ fontWeight: 300 }}>{NgrxAuth.policyNumber}</span></p>
              <p className='policyNum' style={{ margin: '5px 0px' }}>{localize('common.header.certificate')}: <span style={{ fontWeight: 300 }}>{NgrxAuth.certificateNumber}</span></p>
            </div>
            <Divider />
            <List>
              <ListItem button onClick={this.state.openMember === true ? () => this.setState({ openMember: false }) : () => this.setState({ openMember: true })}>
                <ListItemText primary={localize('common.header.member')} />{/* member */}
                {this.state.openMember ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={this.state.openMember} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>

                  <ListItem button onClick={(e) => { self.updateTab(e, 'MemberSummary') }}>
                    <ListItemText inset primary={localize('pages.Member.tab1')} />{/* member summary */}
                  </ListItem>

                  <ListItem button onClick={this.pushBenefits}>
                    <ListItemText inset primary={localize('pages.Member.tab2')} />{/* benefits */}
                  </ListItem>

                  {this.props.memberSummary && this.props.memberSummary.isHCSAAvailable
                    ? <ListItem button onClick={this.pushHcsa}>
                      <ListItemText inset primary={localize('pages.Member.tab3')} /> {/* hcsa */}
                    </ListItem>
                    : null}

                  {this.props.memberSummary && this.props.memberSummary.isPensionAvailable
                    ? <ListItem button onClick={this.pushPension}>
                      <ListItemText inset primary={localize('pages.Member.pension')} />{/* pension */}
                    </ListItem>
                    : null}

                </List>
              </Collapse>
              {isBenefitsAvailable
                ? <ListItem button onClick={(e) => { self.updateTab(e, 'Claims') }} >
                  <ListItemText primary={localize('common.header.claims')} />{/* claims */}
                </ListItem> : null}

              {NgrxAuth.isAnyMemberResource
                ? <ListItem button onClick={(e) => { self.updateTab(e, 'Resources') }}>
                  <ListItemText primary={localize('common.header.resources')} />{/* resources */}
                </ListItem>
                : null}
              {isProvidersAvailable && <ListItem button onClick={(e) => { self.updateTab(e, 'Providers') }} >
                <ListItemText primary={localize('common.header.providers')} />{/* providers */}
              </ListItem>}

              <Divider />

              {useLocale && <ListItem button onClick={this.props.toggleLanguage}>
                <ListItemText primary={localize('common.nav.language')} />{/* lang */}
              </ListItem>}

              <About type={'menu'} appContent={appContent.about} />

              <ListItem button onClick={this.pushFaq}>
                <ListItemText primary={localize('common.contactus.faq')} />{/* faq */}
              </ListItem>

              <ContactUs type={'menu'} appContent={appContent.contact}/>

              <ListItem button onClick={this.logout} >
                <ListItemText primary={localize('pages.home.logout')} />{/* logout */}
              </ListItem>

              <div className={'responsiveMenuBottom'} style={{ textAlign: 'center', padding: '30px 0px' }}>
                <Quicklinks type={'menu'} showPrintClaims={this.showPrintClaims()} />
                <br />
                {NgrxAuth.canSubmitClaim ? <RBButton
                  className={classnames(classes.raisedButton, classes.submitClaimButton)}
                  label={localize('common.header.submitClaim')}
                  containerElement='label'
                  primary
                  variant='contained'
                  onClick={self.submitClaim}
                  disabled={this.props.isLoading}
                  icon={<Icon color='inherit'>add</Icon>}
                /> : null}
              </div>

              <ListItem button onClick={this.handleToggle} >
                <ListItemText style={{ textAlign: 'center' }} primary={localize('common.header.closeMenu')} />{/* close */}
              </ListItem>

            </List>
          </div>
        </Drawer>
      </Row>
    )
  }

  render () {
    const { classes = {} } = this.props

    return (
      <Card className={classnames('header', classes.headerCard)}>
        <Grid fluid className='mainHeader'>
          {this.renderMobileHeader()}
          {this.renderDesktopHeader()}
        </Grid>
      </Card>

    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    user: state.user,
    pageLoading: state.LogoutReducers.pageLoading,
    isLoading: state.memberSummaryReducer.isLoading,
    currentPath: (state.router.location && state.router.location.pathname) || '',
    memberSummary: state.memberSummaryReducer.memberSummary,
    appContent: state.AppContentReducer.appContent
  }
}

const ConnectedHeader = connect(mapStateToProps, {
  logout,
  toggleLanguage,
  push,
  submitAgain
})(injectIntl(Header))

const styles = {
  ...TabStyles,
  ...ButtonStyles,
  ...HeaderStyles,
  ...DrawerStyles,
  hamburgerIcon: {
    ['@media all and (max-width:1330px)']: { // eslint-disable-line no-useless-computed-key
      display: 'block'
    }
  },
  submitClaimButton: {
    minWidth: 186
  },
  tabBar: {
    flex: 1,
    '& button': {
      width: 'auto !important'
    }
  },
  headerLogo: {
    '& img': {
      maxWidth: '100%',
      width: '100%',
      position: 'relative',
      zIndex: 200
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
    height: 138,
    width: 138,
    cursor: 'pointer',
    ['@media all and (max-width:1330px)']: { // eslint-disable-line no-useless-computed-key
      minHeight: 96,
      padding: '15px 0'
    }
  }
}

export default withStyles(styles)(ConnectedHeader)



// WEBPACK FOOTER //
// ./src/widgets/common/Header.js